import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=79d3c32e"
import script from "../../controllers/course/course-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/course/course-edit.js?vue&type=script&lang=js&external"
import style0 from "./CourseEdit.vue?vue&type=style&index=0&id=79d3c32e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports